/* INDUSTRY PEARLS · theme.js. No third-party scripts. */
(function () {
  /* fit the big wordmark to the container width */
  function fit(el) {
    var s = el.querySelector('span'); if (!s) return;
    el.style.fontSize = '';
    var base = parseFloat(getComputedStyle(el).fontSize);
    var avail = el.clientWidth || el.parentElement.clientWidth;
    var pad = parseFloat(getComputedStyle(el.parentElement).paddingLeft) || 0;
    var target = (el.parentElement.clientWidth - pad * 2);
    var w = s.getBoundingClientRect().width;
    if (w > 0 && target > 0) el.style.fontSize = (base * target / w).toFixed(2) + 'px';
  }
  function fitAll() { document.querySelectorAll('[data-fit]').forEach(fit); }
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitAll); else window.addEventListener('load', fitAll);
  fitAll();
  var rt; window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(fitAll, 120); });

  /* add to bag without leaving the page */
  var bag = document.querySelector('[data-bag-count]');
  function setCount(n) {
    document.querySelectorAll('[data-bag-count]').forEach(function (el) { el.textContent = '(' + n + ')'; el.hidden = n < 1; });
  }
  document.addEventListener('submit', function (e) {
    var f = e.target.closest('form[data-add]'); if (!f) return;
    e.preventDefault();
    var btn = f.querySelector('[type=submit]'); var label = btn.textContent;
    btn.disabled = true; btn.textContent = 'Adding';
    fetch(window.Shopify.routes.root + 'cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(f) })
      .then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function () { return fetch(window.Shopify.routes.root + 'cart.js').then(function (r) { return r.json(); }); })
      .then(function (c) { setCount(c.item_count); btn.textContent = 'Added'; setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 1800); })
      .catch(function () { btn.textContent = 'Sold out'; setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 1800); });
  });

  /* cart page: quantity buttons submit the form */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty]'); if (!b) return;
    var input = document.getElementById(b.getAttribute('data-qty'));
    var v = parseInt(input.value, 10) + parseInt(b.getAttribute('data-step'), 10);
    input.value = Math.max(0, v);
    input.form.submit();
  });
})();
